import axios from "axios";
import { getBaseUrl } from "../helpers/utility";

/**
 * Unauthenticated axios for guest telemed flow (avoids global 401 → login redirect).
 *
 * Uses visiting endpoints only — not `/nursing_home_chats/locations.json`.
 *
 * - GET  nursing_home_external_telemedicines/locations.json?practice_key=&org_code= (from landing URL)
 * - GET  visiting/location_providers_with_specialties.json?location_id=&keyword= (keyword optional; min length enforced in UI)
 * - POST /telemeds/guest_flow/request_session.json  { location_id, provider_id }
 */

function createGuestClient() {
  const base = getBaseUrl();
  if (!base?.api_url) {
    throw new Error("API URL is not configured.");
  }
  return axios.create({
    baseURL: base.api_url.replace(/\/$/, ""),
    params: {
      new_chat: 1,
      tz: new Date().getTimezoneOffset(),
    },
  });
}

function unwrapList(res) {
  const r = res?.data?.response ?? res?.data;
  if (r?.code === 0 || r?.code === "0") {
    const d = r.data;
    return Array.isArray(d) ? d : d ? [d] : [];
  }
  throw new Error(r?.msg || "Request failed");
}

function unwrapObject(res) {
  const r = res?.data?.response ?? res?.data;
  if (r?.code === 0 || r?.code === "0") {
    return r.data ?? {};
  }
  throw new Error(r?.msg || "Request failed");
}

/**
 * @param {{ practice_key?: string, org_code?: string, org?: string }} [query] — from landing URL (?practice_key=&org= or ?org_code=)
 */
export async function fetchGuestTelemedLocations(params = {}) {
  const client = createGuestClient();
  const res = await client.get("/nursing_home_external_telemedicines/locations.json", {
    params
  });
  return unwrapList(res);
}

/**
 * @param {Record<string, string | number>} params — e.g. { location_id, keyword? }
 */
export async function fetchGuestTelemedProviders(params) {
  const client = createGuestClient();
  const res = await client.get(
    "/nursing_home_external_telemedicines/providers.json?",
    {
      params,
    }
  );
  return unwrapList(res);
}

export async function requestGuestTelemedSession(payload) {
  const client = createGuestClient();
  const res = await client.post("/nursing_home_external_telemedicines/request_telemedicine_session.json", payload);
  return unwrapObject(res);
}
